/**
 * @file  src\hooks\usePrevious.js
 * @brief  This file is responsible for usePrevious hook
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { useRef, useEffect } from "react";

export const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }